import type { RecommendationContext } from "@memorang/types";
import { selectStudyRecommendations } from "./application/select-study-recommendations";
import { parseRecommendationContext } from "./contract/recommendation-context-schema";
import type {
	AxisFilters,
	ContextRecommendationResult,
} from "./contract/recommendation-context-types";

export type {
	AxisFilters,
	ContextRecommendationResult,
} from "./contract/recommendation-context-types";
export type { RecommendationContext };
export { parseRecommendationContext };

export const recommendStudySessionsFromContext = ({
	context: rawContext,
	...input
}: {
	context: RecommendationContext;
	target: { axisId: string; valueId: number };
	preferences?: AxisFilters;
	filters?: AxisFilters;
	sessionCount: number;
	itemsPerSession?: number;
	durationMinutes?: 5 | 10 | 20;
	onePerTrack?: boolean;
}): ContextRecommendationResult =>
	selectStudyRecommendations({
		...input,
		context: parseRecommendationContext(rawContext),
	});
